import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import parsePhoneNumber, { type CountryCode } from "libphonenumber-js";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPhoneNumber(phoneNumber: string) {
  const parsed = parsePhoneNumber(phoneNumber, { defaultCountry: "US" });
  return parsed?.formatInternational() || phoneNumber;
}

export function getPhoneNationalNumber(
  phone: string,
  countryCode: string = "us"
): string {
  try {
    const parsed = parsePhoneNumber(phone, {
      defaultCountry: countryCode.toUpperCase() as CountryCode,
    });
    return parsed?.nationalNumber ?? "";
  } catch (error) {
    console.error("Error parsing phone number", error);
    return "";
  }
}

export function isPhoneValid(phone: string, countryCode: string = "us") {
  try {
    const parsed = parsePhoneNumber(phone, {
      defaultCountry: countryCode.toUpperCase() as CountryCode,
    });
    return parsed?.isPossible() ?? false;
  } catch (error) {
    console.error("Error validating phone number", error);
    return false;
  }
}
